import React from 'react';

import * as graphql from 'generated/graphql';
import { useLoading } from 'modules';



export interface IData {
  allAccessEnabled: boolean;
  userTypeName?: graphql.UserTypeName;
}

export function useQuery() {
  const tuple = graphql.useOnboardingUserTypeActivityQuery({ fetchPolicy: 'no-cache' });
  const [saveUserType, saveUserTypeTuple] = __useSaveUserType(tuple.data?.loggedInUser?.id ?? '');
  const loading = useLoading([tuple, saveUserTypeTuple]);



  return React.useMemo(
    () => {
      const data: IData = {
        allAccessEnabled: tuple.data?.allAccessEnabled ?? false,
        userTypeName: tuple.data?.loggedInUser?.type?.name
      };

      return {
        ...tuple,
        loading,
        data,
        mutations: { saveUserType }
      };
    },
    [
      saveUserType,
      loading,
      tuple
    ]
  );
}



function __useSaveUserType(siteUserId: string) {
  const [fnRunQuery, tuple] = graphql.useSaveUserTypeMutation();

  async function fnWrappedMutate(type: graphql.UserTypeName) {
    await fnRunQuery({
      variables: {
        siteUserId,
        type
      }
    });
  }

  return [fnWrappedMutate, tuple] as const;
}
